import axios from "axios";
import {message} from "antd";
import {CommonStore} from "../store";

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
axios.interceptors.request.use((request) => {
    return request
});
let URL = `${window.location.origin}/api`


axios.defaults.baseURL = URL;

axios.interceptors.response.use(
    (response: any) => {
        let {data} = response;
        if (data.code === 200 || data.code === '0000') {
            return data;
        } else if (data.code === 4001 || data.code === 401) {
            message.error(data.msg)
            CommonStore.toLogOut('401')
        }else if (!data.code ) {//导出错误数据
            return Promise.reject(data)
        }
         else {
            message.error(data.msg)
            return Promise.reject(data)
        }
    },
    (err: any) => {
        if (err.response.status === 401) {
            // message.error('用户尚未登录')
            CommonStore.toLogOut('401')
        }else if(err.response.status === 403){
            message.error('无权访问')
        }
         else{
            message.error('系统异常，请稍后重试')
        }
        return Promise.reject(err)
    }
);
export const axiosUtil = axios

